<template>
  <button class="code-btn" color-primary border-primary :class="{'invalid': codeInvalid, 'disabled': (codeInvalid||codeDisable)}" @click="getCode">
    <span>{{btnText || initBtnText}}</span>
  </button>
</template>

<script>
import APP from '@/config/app.config'
import Countdown from '@/utils/countdown'

// mixin
import FunMixin from '@/mixins/funMixin'

window.countDown = new Countdown()
let customData = {
  btnTextFmt: '(nums)重新获取'
}

export default {
  name: 'phoneCode',
  components: {},
  mixins: [FunMixin],
  props: {
    auto: { // 是否自动调用获取验证码方法
      type: Boolean,
      default: false
    },
    codeInvalid: { // 按钮对应的手机号输入框是否不通过校验
      type: Boolean,
      default: true
    },
    initBtnText: { // 按钮初始文字
      type: String,
      default: '获取验证码'
    },
    countDownNum: {
      type: Number,
      default: APP.COUNT_DOWN
    }
  },
  data() {
    return {
      codeDisable: false,
      timeNums: 0
    }
  },
  computed: {
    btnText() {
      if (this.timeNums === 0) return ''
      return customData.btnTextFmt.replace('num', this.timeNums)
    }
  },
  methods: {
    async getCode() {
      await this.m_clickDebounce('getCode')
      if (this.codeInvalid) {
        this.$emit('getCode', 'codeInvalid')
        return
      }
      if (this.codeDisable) { // 将按钮不可点击返回给父级
        this.$emit('getCode', 'codeDisable')
        return
      }
      this.$emit('getCode', 'getCode')
    }
  },
  mounted() {
    this.$on('getCodeSuccess', phoneCode => {
      customData.btnTextFmt = phoneCode.btnTextFmt
      window.countDown.run((s) => {
        this.timeNums = s
        this.codeDisable = true
      }, () => {
        this.timeNums = 0
        this.codeDisable = false
      })
    })
    this.$on('cancelCountDown', () => {
      window.countDown.initialize(true, this.countDownNum)
      this.timeNums = 0
      this.codeDisable = false
    })
  },
  created() {
    if (window.countDown.countTime < this.countDownNum) {
      window.countDown.initialize(false, window.countDown.countTime)
      window.countDown.run((s) => {
        this.timeNums = s
        this.codeDisable = true
      }, () => {
        this.timeNums = 0
        this.codeDisable = false
      })
    } else {
      window.countDown.initialize(false, this.countDownNum)
      if (this.auto) { // 待测试
        this.getCode()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.code-btn{
  width: 216px;
  height: 70px;
  line-height: 70px;
  flex-shrink: 0;
  border: 1px solid;
  background-color: rgba(9,187,7,0.00) !important;
  border-radius: 100px;
  font-size: 28px;
  @extend %flex-center;
  &.invalid {
    border-color: #e5e5e5;
    color: #e5e5e5;
  }
  &.disabled{
    border-color: $border-disable-color;
    color: #bbb;
    font-size: 26px;
  }
}
</style>
